import { render, staticRenderFns } from "./gw-loading.vue?vue&type=template&id=62836a5c"
import script from "./gw-loading.vue?vue&type=script&lang=js"
export * from "./gw-loading.vue?vue&type=script&lang=js"
import style0 from "./gw-loading.vue?vue&type=style&index=0&id=62836a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports